<template>
  <section class="section level l1" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
        </div>
        <div class="menuSc">
          <div class="expCnt">
            <h4>{{point.toLocaleString('id')}} point</h4>
            <div class="expLabel">dari 1.400pt</div>
            <div class="theExp">
              <div class="exp" :style="{width: `${point / 1400 * 100}%`}"></div>
            </div>
            <div class="info" v-if="nextPrize > 0">
              {{nextPrize.toLocaleString('id')}}
              point lagi untuk hadiah berikutnya</div>
          </div>
          <div class="pointHistory"
            v-on:click="openHistory">
            Lihat riwayat perolehan point
            <div class="more"></div>
          </div>
          <div class="menuCnt menuCntMobile">
            <h4>Menu</h4>
            <div class="pointHistory soundOff" v-on:click="$emit('toggleSound')"
              v-if="muted">Sound Off</div>
            <div class="pointHistory sound" v-on:click="$emit('toggleSound')"
              v-else>Sound On</div>
            <div class="pointHistory share" v-on:click="$emit('share')">
              Bagikan <div class="more"></div>
            </div>
            <div class="pointHistory vase" v-on:click="$emit('changeAcc')">
              Ganti Vase <div class="more"></div>
            </div>
            <div class="pointHistory help" v-on:click="$emit('help')">
              Bantuan <div class="more"></div>
            </div>
            <div class="pointHistory info" v-on:click="$emit('info')">
              Informasi <div class="more"></div>
            </div>
            <div class="pointHistory leaderboard" v-on:click="$emit('leaderboard')">
              Leaderboard <div class="more"></div>
            </div>
            <div class="pointHistory treeIcon" v-on:click="$emit('tree')">
              Pohon Kamu <div class="more"></div>
            </div>
          </div>
          <div class="menuCnt">
            <h4>Klaim Hadiah</h4>
            <div class="menuItem loadingPrice" v-if="loading"></div>
            <div v-else>
              <div class="menuItem allClaimed" v-if="claimedCount > 0"
                v-on:click="openClaimed">
                {{claimedCount}} hadiah sudah di klaim
                <div class="more"></div>
              </div>
              <div :class="{menuItem: true, locked: point < item.point}"
                v-for="(item, i) in price" :key="i">
                <div class="menuIcon" :class="item.icon"></div>
                <div>
                  {{item.name}}
                  <p class="p2">Terbuka di <b>{{item.point.toLocaleString('id')}}pt</b></p>
                  <p v-if="item.description && item.description !== ''">{{item.description}}</p>
                </div>
                <div :class="{claim: true, claimed: item.claimed}"
                  v-on:click="claim(item, i)">
                  <span v-if="item.claimed">Claimed</span>
                  <span v-else>Claim</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <LevelClaimed ref="levelClaimed"/>
    <PointHistory ref="pointHistory"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import LevelClaimed from '@/components/LevelClaimed.vue';
import PointHistory from '@/components/PointHistory.vue';

export default {
  name: 'home',
  components: { Confirmation, LevelClaimed, PointHistory },
  props: ['muted'],
  data() {
    return {
      point: 0,
      loading: true,
      show: false,
      price: [],
      claimedCount: 0,
      nextPrize: 0,
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.getData();
    },
    close() {
      this.show = false;
    },
    getData() {
      this.point = this.$session.get('tufi2_point') || 0;
      this.loading = true;
      this.$http.get(this.$config.uri('user/prize')).then((r) => {
        this.loading = false;
        this.price = (r.data.status === 200) ? r.data.data : [];
        this.claimedCount = (r.data.status === 200) ? r.data.claimedCount : [];
        this.nextPrize = (r.data.status === 200) ? r.data.nextPrize : 0;
      });
    },
    openHistory() {
      this.$refs.pointHistory.open();
    },
    openClaimed() {
      this.$refs.levelClaimed.open();
    },
    claim(item, i) {
      if (this.point < item.point) return;
      this.price[i].claimed = true;
      this.$http.get(this.$config.uri(`user/price/${item.id}/claim`)).then((r) => {});
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.level.l1{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;
    padding: 0 10px 40px;
    box-sizing: border-box;
    width: 400px;
    z-index: 3;
    right: -400px;
    transition: all .5s ease;
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/FG-Kanan.svg);
      background-size: auto 120px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
    .rightContentIn{
      position: relative;
      z-index: 3;
      .menuSc{
        margin: -10px -10px 0;
        border-top: rgba(0, 0, 0, .1) 1px solid;
        padding: 12px 10px 0;
        overflow: auto;
        height: calc(100vh - 86px);
      }
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    padding: 16px 20px 20px;
    @media (min-width: 480px) {
      padding-left: 10px;
    }
    .backBtn{
      width: 46px; height: 46px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 24px;
      margin: 16px 0 14px;
      color: #006519;
    }
  }
  .profilePict{
    width: 94px; height: 94px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 16px;
    background-position: center;
    background-size: cover;
  }
  .profileInfo{
    text-align: center;
    padding-bottom: 20px;
    h4{
      margin: 0;
      font-size: 20px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
  }
  .expCnt{
    background-color: rgba(255, 255, 255, .7);
    margin: 0 10px 10px;
    border-radius: 5px;
    padding: 16px 20px 20px;
    position: relative;
    h4{
      margin: 0 0 6px;
      font-size: 16px;
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 18px;
      font-size: 14px;
    }
    .theExp{
      height: 12px;
      background-color: #ccc;
      border-radius: 50px;
      .exp{
        height: 100%;
        max-width: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
      }
    }
    .info{
      font-size: 12px;
      color: #555;
      text-align: right;
      margin: 6px 5px -8px;
    }
  }
  .progressCnt{
    background-color: rgba(255, 255, 255, .7);
    margin: 0 10px;
    border-radius: 10px;
    padding: 16px 20px 52px;
    h4{
      margin: 0 0 10px;
    }
    .theProgress{
      display: flex;
      height: 80px;
      justify-content: space-between;
      .progressItem{
        height: 100%;
        font-size: 10px;
        text-align: center;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .label{
          position: absolute;
          left: 50%; margin-left: -15px;
          text-align: center;
          bottom: -34px;
          width: 30px;
          span{
            display: block;
            font-size: 14px;
            font-weight: bold;
            margin-top: -1px;
          }
        }
        .progress{
          width: 8px;
          background-color: #8EC642;
          background-color: #6aa722;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
  }
  .pointHistory{
    padding: 14px 20px 12px;
    font-weight: bold;
    color: #444;
    position: relative;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 10px 10px;
    border-radius: 5px;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    transition: all .3s ease;
    cursor: pointer;
    padding-left: 48px;
    &:before{
      content: "";
      position: absolute;
      left: 10px; top: 5px; bottom: 5px; width: 30px;
      background-image: url(../assets/history.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .8;
    }
    &:hover{
      background-color: rgba(255, 255, 255, .8);
    }
    .more{
      position: absolute;
      right: 12px; top: 12px;
      width: 20px; height: 20px;
      background-position: center;
      background-size: 16px auto;
      background-repeat: no-repeat;
      background-image: url(../assets/arrow-right-black.png);
      opacity: .3;
    }
  }
  .menuCnt{
    padding: 10px 0 40px;
    h4{
      margin: 0 20px 6px;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      padding-left: 90px;
      padding-right: 106px;
      font-weight: bold;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .7);
      background-color: #fff;
      // background-image: linear-gradient(to left, #8EC642, #669922);
      // color: #fff;
      margin: 0 10px 10px;
      border-radius: 5px;
      font-size: 17px;
      min-height: 80px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      &.loadingPrice{
        background-color: rgba(255, 255, 255, 0.5);
        background-color: transparent;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
        height: 60px;
      }
      &.allClaimed{
        background-color: rgba(255, 255, 255, 0.5);
        padding: 13px 20px;
        min-height: 0;
        transition: all .3s ease;
        cursor: pointer;
        &:hover{
          background-color: rgba(255, 255, 255, .8);
        }
        &:active{
          background-color: #ddd;
        }
        .more{
          position: absolute;
          right: 12px; top: 12px;
          width: 20px; height: 20px;
          background-position: center;
          background-size: 16px auto;
          background-repeat: no-repeat;
          background-image: url(../assets/arrow-right-black.png);
          opacity: .3;
        }
      }
      p{
        font-size: 14px;
        margin: 0;
        font-weight: normal;
        &.p2{
          color: #767676;
          font-size: 13px;
          margin: 2px 0 0;
        }
      }
      .claim{
        position: absolute;
        right: 12px; top: 50%;
        transform: translateY(-50%);
        background-position: center;
        background-size: 16px auto;
        background-repeat: no-repeat;
        background-color: #01b0b7;
        padding: 6px 14px;
        border-radius: 50px;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        transition: all .3s ease;
        cursor: pointer;
        &:hover{
          background-color: #5351a4;
        }
        &:active{
          background-color: #222;
        }
        &.claimed{
          background-color: #ddd;
          color: #999;
        }
      }
      .menuIcon{
        position: absolute;
        left: 14px; top: 10px;
        width: 60px; height: 60px;
        background-position: center;
        background-size: 44px auto;
        background-repeat: no-repeat;
        // background-color: #eee;
        border-radius: 10px;
        &.pot1{
          background-image: url(../assets/char/Pot1-thumb.png);
        }
        &.pot2{
          background-image: url(../assets/char/Pot2-thumb.png);
        }
        &.pot3{
          background-image: url(../assets/char/Pot3-thumb.png);
        }
        &.pot4{
          background-image: url(../assets/char/Pot4-thumb.png);
        }
        &.planting-tree{
          background-image: url(../assets/planting.png);
        }
      }
      &.locked{
        .menuIcon{
          // filter: grayscale(1);
        }
        .claim{
          cursor: default;
          background-color: #999;
          background-image: url(../assets/locked.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          span{
            visibility: hidden;
          }
        }
      }
    }
    &.menuCntMobile{
      padding-bottom: 4px;
      display: none;
      @media (max-width: 760px) {
        display: block;
      }
      .pointHistory{
        margin-bottom: 6px;
        &.sound:before{
          background-image: url(../assets/music-black.png);
        }
        &.soundOff:before{
          background-image: url(../assets/mute-black.png);
        }
        &.share:before{
          background-image: url(../assets/sharing-black.png);
        }
        &.vase:before{
          background-image: url(../assets/sprout-black.png);
        }
        &.leaderboard:before{
          background-image: url(../assets/trophy-black.png);
        }
        &.info:before{
          background-image: url(../assets/info-black.png);
        }
        &.treeIcon:before{
          background-image: url(../assets/tree-black.png);
        }
      }
    }
  }
}
</style>
